import React, { useEffect, useLayoutEffect, useState } from 'react'
import cx from 'classnames'
import getUrl from 'front-end-core/core/url'
import { LEGISLATION_KEY_PICKS } from 'constants/feature-flags'
import { LEGISLATION_CATEGORIES, LEGISLATION } from 'constants/controllers'
import LegislationTiledMenuContainer from 'redux/containers/components/tiled-menu/LegislationTiledMenuContainer'
import ConnectedKeyPicks from './ConnectedKeyPicks'

const LegislationFoldersMenu = ({
  aol,
  isLogged,
  isTiledMenuLoaded,
  setTiledMenuIsLoaded,
  setSignUpModalIsOpen,
  legislationFolders,
  setLegislationFolders
}) => {
  const [isLegTileMenuLoaded, setIsLegTileMenuLoaded] = useState(false)

  const handleOnClick = () => !isLogged && setSignUpModalIsOpen(true)
  const cxNames = {
    tile: {
      borderColor: 'b--dark-orchid',
      iconColor: 'cadet-blue',
      onHover: 'legislation-tile'
    }
  }

  useEffect(() => {
    setLegislationFolders(legislationFolders)
  }, [legislationFolders])

  useLayoutEffect(() => {
    isLegTileMenuLoaded && setTiledMenuIsLoaded(true)
  }, [isLegTileMenuLoaded, setTiledMenuIsLoaded])

  return (
    <div className={cx('bg-ghost-grey pb9')}>
      <div className='layout-width-constraint legislation-folders-container'>
        {LEGISLATION_KEY_PICKS && (
          <ConnectedKeyPicks
            {...{
              aol,
              className: 'pv8',
              cxNames,
              iconName: 'icon-legislation',
              handleOnClick,
              getUrl: item => getUrl(LEGISLATION, { aol, path: item.id }),
              newTab: false
            }}
          />
        )}
        <LegislationTiledMenuContainer
          getUrl={query => params => getUrl(LEGISLATION_CATEGORIES, { aol, ...params }, query)}
          category='Legislation'
          {...{ cxNames, setIsLegTileMenuLoaded }}
        />
      </div>
    </div>
  )
}

export default LegislationFoldersMenu
